import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=f178a314&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=ts"
export * from "./DashBoard.vue?vue&type=script&lang=ts"
import style0 from "./DashBoard.vue?vue&type=style&index=0&id=f178a314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f178a314",
  null
  
)

export default component.exports